import React from "react";
import moment from "moment";

import { Grid } from "material-ui";
import DocumentMeta from 'react-document-meta';

// @material-ui/icons/
import Share from "@material-ui/icons/Share";
import Update from "@material-ui/icons/Update";
import AddAlert from "@material-ui/icons/AddAlert";



import { ProfileCard, DappMiniCard, RegularCard, Button, TableSimple, ItemGrid, DappIcon, Snackbar } from "components";
// import EthAlt from 'react-cryptocoins/dist/icons/ETH-alt';
import { NavLink } from "react-router-dom";
// import ReactGA from 'react-ga';

var Reflux = require('reflux');
var createReactClass = require('create-react-class');
var DappsStore = require('../../stores/DappsStore');
var UsersStore = require('../../stores/UsersStore');

const style = {
    centerText: {
        textAlign: "center",
    },
    rate: {
        fontSize: "42px",
        fontWeight: "bold",
        color: "#ff9800",
        marginBottom: "2px",
        marginTop: "8px",
    },
    note: {
        marginTop: "10px",
        marginBottom: "10px"
    },
    shareButton: {
        padding: "7px 8px",
        minWidth: "64px",
        fontSize: "0.8125rem",
        minHeight: "32px",
        margin: "0px 4px",
    }
};


const UserProfile = createReactClass({
    mixins: [
        Reflux.connect(DappsStore, "data"),
        Reflux.connect(UsersStore, "data"),
    ],
    getInitialState: function() {
        return {
            transactions: [],
            address: '',
            dapps: [],
            balance: 0,
            totalVolume: 0,
            totalDapps: 0,
            totalTranscations: 0,
            isConnected: false,
        };
    },
    getTitle(user) {
        if (this.getLocationUser()) {
            return 'Address DApps: ' + user;
        } else {
            return 'My DApps'
        }
    },
    getOgTitle(user) {
        if (this.getLocationUser()) {
            return '✅ Address DApps ' + user + ': ' + this.getUrlWithoutProtocol(user);
        } else {
            return '✅ My DApps: ' + this.getUrlWithoutProtocol(user);
        }
    },
    getUrlWithoutProtocol(user){
        return 'dappstore.link/user/' + user;
    },
    getUrl(user) {
        return 'https://' + this.getUrlWithoutProtocol(user);
    },
    getFacebookShareUrl(user) {
        return 'https://www.facebook.com/sharer/sharer.php?u=' + this.getUrl(user) + '&message=' + this.getOgTitle(user);
    },
    getTwitterShareUrl(user) {
        return 'https://twitter.com/share?url=' + this.getUrl(user) + '&text=' + this.getOgTitle(user);
    },

    numberFormat(number) {
        if (typeof number === 'undefined') {
            return 0;
        }
        number = parseFloat(number);
        return number.toFixed(4);
    },

    componentDidMount: function() {
        var intervalId = setInterval(this.timer, 1000);
        // store intervalId in the state so it can be accessed later:
        this.setState({
            intervalId: intervalId
        });
    },

    componentWillUnmount: function() {
        // use intervalId from the state to clear the interval
        clearInterval(this.state.intervalId);
    },


    // https://twitter.com/share?url=URLENCODED_URL&via=TWITTER_HANDLE&text=TEXT
    getBody(user) {
        const facebookShareUrl = this.getFacebookShareUrl(user);
        const twitterShareUrl = this.getTwitterShareUrl(user);
        return <div>
                <Grid container>

                       <ItemGrid xs={12} sm={6} md={6} lg={3}>
                            <div>ETH Balance:</div>
                            <h3>{ this.state.balance } ETH</h3>
                        </ItemGrid>
                       <ItemGrid xs={12} sm={6} md={6} lg={3}>
                            <div>Ðapps Volume</div>
                            <h3>{ this.numberFormat(this.state.totalVolume)} ETH</h3>
                        </ItemGrid>
                       <ItemGrid xs={12} sm={6} md={6} lg={3}>
                            <div>Total Ðapps Played</div>
                            <h3>{ this.state.totalDapps }</h3>
                        </ItemGrid>
                       <ItemGrid xs={12} sm={6} md={6} lg={3}>
                            <div>Ðapps Transactions</div>
                            <h3>{ this.state.totalTranscations }</h3>
                        </ItemGrid>
                </Grid>
                <br/>
                <p>
              <Button style={style.shareButton}  color="facebook" onClick={(e) => window.open(facebookShareUrl, 'share', 'width=600,height=400')} round>
                <Share/>   Facebook
              </Button>
              <Button style={style.shareButton} color="info" onClick={(e) => window.open(twitterShareUrl, 'share', 'width=600,height=400')} round>
                <Share/>   Twitter
              </Button>
              </p>
        </div>
    },

    getWeb3(callback) {
        if (typeof window.web3 === 'undefined') {
            // no web3, use fallback
            console.error("Please use a web3 browser");
        } else {
            Promise.all([
                import('web3'),
            ])
            .then(([Web3]) => {

                // window.web3 == web3 most of the time. Don't override the provided,
                // web3, just wrap it in your Web3.
                var myWeb3 = new Web3(window.web3.currentProvider);
                // the default account doesn't seem to be persisted, copy it to our
                // new instance
                myWeb3.eth.defaultAccount = window.web3.eth.defaultAccount;
                callback(myWeb3);
            });
        }
    },

    componentWillMount() {
        var user = this.getLocationUser();
        if (user) {
            this.getTransactions(user);
        } else {
            /*
            if(this.web3 && this.web3.isConnected()) {
              this.setState({isConnected: true});
            }
            */
            var self = this;
            this.getWeb3(function(data) {
                let user = data.eth.defaultAccount;
                if (user) {
                    self.getTransactions(user);
                }
            });
        }
    },

    getTransactions(user) {
        let self = this;
        UsersStore.getUserPromise(user).then(function(e) {
            let dappsData = self.getDapps(e);
            dappsData.address = user;
            self.setState(dappsData);
        });
    },

    getTime(timeStamp) {
        return moment(1000 * parseInt(timeStamp, 10)).locale('en').startOf('hour').fromNow();
    },

    getTransactionsData() {
        let data = [];
        for (var i = 0; i < this.state.transactions.length; i++) {
            let dapp = DappsStore.getDappById(+this.state.transactions[i].dapp_id);
            if (!dapp) continue;
            let date = this.getTime(+this.state.transactions[i].time_stamp);
            data[i] = [
                <NavLink
                to={'/dapp/' + dapp.slug}
                ><DappIcon dapp={dapp} size={22} style={ {
                    background: 'white',
                    verticalAlign: 'bottom',
                    marginRight: '6px',
                }} /><span>{ dapp.title }</span>
                </NavLink>,
                this.numberFormat(this.state.transactions[i].value) + " ETH",
                date,
                <a href={"https://etherscan.io/tx/" + this.state.transactions[i].hash} target="_blank">
                    {this.state.transactions[i].hash}
                </a>
            ];
        }
        return data;
    },

    getDapps(transactions) {
        let dappsData = [];
        let totalVolume = 0;
        let totalDapps = 0;
        let totalTranscations = 0;
        for (var i = 0; i < transactions.length; i++) {
            let dappId = +transactions[i].dapp_id;
            if (typeof dappsData[dappId] === 'undefined') {
                dappsData[dappId] = {
                    dapp_id: dappId,
                    last_time: +transactions[i].time_stamp,
                    transactions: 1,
                    value: +transactions[i].value,
                };
                totalDapps++;
            } else {
                dappsData[dappId].transactions += 1;
                dappsData[dappId].value += +transactions[i].value;
            }
            totalVolume += +transactions[i].value;
            totalTranscations++;
        }
        dappsData.sort((a, b) => (b.last_time - a.last_time));
        return {
            dapps: dappsData,
            transactions: transactions,
            totalTranscations: totalTranscations,
            totalDapps: totalDapps,
            totalVolume: totalVolume,
        };
    },

    getDappsItems() {
        if (typeof DappsStore.data.dapps === 'undefined') {
            return false;
        }
        return this.state.dapps.map((value, index) => {
            let dapp = DappsStore.getDappById(value.dapp_id);
            if (!dapp) return false;
            return (
                <ItemGrid xs={12} sm={6} md={6} lg={4} key={ index }>
                <NavLink
                to={'/dapp/' + dapp.slug}
                >
            <DappMiniCard
                icon={ <DappIcon dapp={dapp} size={72} style={ {
                    background: 'white',
                    borderRadius: '50%',
                }} /> }
                iconColor={ DappsStore.getColorByCategory(dapp.category).name }
                title={value.transactions + " TX, " + this.numberFormat(value.value) + " Eth"}
                description={ dapp.title }
                statIcon={ Update }
                statText={ this.getTime(value.last_time)}
                />
                </NavLink>
        </ItemGrid>
            )
        });
    },

    getProfileCard(address) {
        return (<ItemGrid xs={12} sm={12} md={12} lg={12}>
          <ProfileCard
            avatar={ <DappIcon hash={ address.substr(-16)} size={130} style={ {
                background: 'white'
            }} /> }
            subtitle={ 'User' }
            title={ address }
            description={ this.getBody(address)}
            />
        </ItemGrid>);
    },

    getTransactionsCard() {
        return <Grid container>
            <ItemGrid xs={12} sm={12} md={12}>
                <RegularCard
            cardTitle="Transactions"
            cardSubtitle={ <span>Latest Transactions</span> }
            headerColor="green"
            content={
            <TableSimple
            hover
            tableHeaderColor="gray"
            tableHead={["Ðapp", "Value", "Age", "TX Hash"]}
            tableData={ this.getTransactionsData()}
            />
            }
            />
            </ItemGrid>
        </Grid>
    },

    timer() {
        let user = this.getLocationUser();
        if( !user ){
            var self = this;
            this.getWeb3(function(data) {
                let user = data.eth.defaultAccount;
                if (user !== self.state.address) {
                    self.onChangeAccount(user);
                    if (user) {
                        self.getTransactions(user);
                    }
                }
            });
        }
    },

    onChangeAccount(nextAddress) {
        this.setState({
            address: nextAddress
        });
    },

    getLocationUser(){
        return this.props.location.pathname.replace('/user/', '');
    },

    render() {
        var user = this.getLocationUser();
        if (!user) {
            user = this.state.address;
        }

        const meta = {
            title: this.getTitle(user),
            description: this.getTitle(user),
            canonical: this.getUrl(user),
            meta: {
                property: {
                    'og:title': this.getTitle(user),
                    'og:description': this.getTitle(user),
                    'og:url': this.getUrl(user)
                }
            }
        };
        if (!user) {
            return <div>
              <Snackbar
                place="tr"
                color="warning"
                icon={AddAlert}
                open={ true }
                message="Sign in to MetaMask - Open up your browser’s MetaMask extension"
                />
            </div>
        } else {
            return (
                <DocumentMeta {...meta}>
                    <Grid container>
                    { this.getProfileCard(user)}
                    <Grid container>
                    { this.getDappsItems(user)}
                    </Grid>
                    { this.getTransactionsCard()}        
                  </Grid>
              </DocumentMeta>
            );
        }
    }
});

export default UserProfile;



// WEBPACK FOOTER //
// ./src/views/UserProfile/UserProfile.jsx